export default __webpack_public_path__ + "static/media/QR_code_PlayStore.c12d014b.png";